export default __webpack_public_path__ + "static/fv-black-text-pattern-7c0a29e29b104564a01440ac0d5cd7ae.avif";